export default __webpack_public_path__ + "static/media/silicon table.5a08aca8.jpeg";